import BadgesSpoiler from "./BadgesSpoiler/src/BadgesSpoiler.vue";
import DatePicker from "./DatePicker/src/DatePicker"
import Drawer from "./Drawer/src/Drawer.vue";
import Dropdown from "./Dropdown/src/Dropdown"
import DropZone from "./DropZone/src/DropZone"
import FinancialSummaryChart from "./Chart/src/FinancialSummaryChart.vue";
import FooterComponent from "./Footer/src/Footer.vue";
import InputToggle from "./InputToggle/src/InputToggle";
import SelectOptgroup from "./SelectOptgroup/src/SelectOptgroup.vue";
import FunctionInput from "./FunctionInput/src/FunctionInput.vue";
import SpotlightInput from "./SpotlightInput/src/SpotlightInput.vue"
import SpotlightInputV2 from "./SpotlightInputV2/src/SpotlightInputV2.vue"
import ToggleAjax from "./ToggleAjax/src/ToggleAjax";
import Topbar from "./Topbar/src/Topbar.vue";

export default {
    BadgesSpoiler,
    DatePicker,
    Drawer,
    Dropdown,
    DropZone,
    FinancialSummaryChart,
    FooterComponent,
    InputToggle,
    SelectOptgroup,
    FunctionInput,
    SpotlightInput,
    SpotlightInputV2,
    ToggleAjax,
    Topbar,
}
